export function getInitials(fullName) {
    if (!fullName || typeof fullName !== "string") return "";
    const nameParts = fullName
      .trim()
      .split(" ")
      .filter((part) => part !== "");
    if (nameParts.length === 0) return "";
    // If only one name, return first character
    if (nameParts.length === 1) return nameParts[0][0].toUpperCase();
    // For two or more names, take first character of first and last name
    const firstInitial = nameParts[0][0].toUpperCase();
    const lastInitial = nameParts[nameParts.length - 1][0].toUpperCase();
    return `${firstInitial}${lastInitial}`;
  }